import { If } from "shared/components/control-statements";
import styles from "styles/mensageria.module.scss";
import { Button } from "shared/components/Button";

export const WhatsAppPreview = ({ components, coupon }) => {

    if (!components?.length) {
        return null;
    }

    const header = components.find(c => c.type === 'HEADER');
    const body = components.find(c => c.type === 'BODY');
    const footer = components.find(c => c.type === 'FOOTER');
    const buttons = components.find(c => c.type === 'BUTTONS');

    console.log('buttons', buttons);
    console.log('template', components);

    return (
        <div className={styles.previewTemplate}>
            <If cond={header}>
                <WhatsAppHeader content={header} />
            </If>
            <If cond={body}>
                <WhatsAppBody content={body} coupon={coupon} />
            </If>
            <If cond={footer}>
                <WhatsAppFooter content={footer} />
            </If>
            <If cond={buttons?.buttons?.length > 0}>
                <div className={styles.templateButtons}>
                    <div className={styles.buttons}>
                        {buttons?.buttons?.map((button, index) => (
                            <div className={styles.button}>{button.text}</div>
                        ))}
                    </div>
                </div>
            </If>
        </div>
    );
}


const WhatsAppHeader = ({ content }) => {
    console.log('header', content);
    return (
        <div className={styles.templateHeader}>
            {content?.format === 'TEXT' && (
                <p>{content?.example}</p>
            )}
            {content?.format === 'IMAGE' && (
                <img src={content?.example?.header_handle?.[0]} id="imagePreview" />
            )}
            {content?.format === 'VIDEO' && <></>}
        </div>
    );
}

const WhatsAppBody = ({ content, coupon }) => {
    return (
        <div
            className={styles.templateBody}
            dangerouslySetInnerHTML={{
                __html: content?.text,
            }}
        />
    );
}

const WhatsAppFooter = ({ content }) => {
    return (
        <div className={styles.templateFooter}>
            {content?.text}
        </div>
    );
}